export default __webpack_public_path__ + "static/phone-image-a96b58563701c77b8884de6f47ef16fa.png";